import { SpeedRounded as ProfilerIcon } from "@mui/icons-material";
import { Alert, Button } from "@mui/material";
import { useSessionStorageStringState } from "store/hooks/stateHooks";

const ProfilerBanner = () => {
  const [profile, setProfile] = useSessionStorageStringState("profile", {
    default: null,
  });

  if ((profile ?? "") === "") {
    return <></>;
  }

  return (
    <Alert
      severity={"error"}
      variant={"filled"}
      icon={<ProfilerIcon fontSize={"inherit"} sx={{ marginRight: "-4px" }} />}
      action={
        <Button color={"inherit"} size={"small"} onClick={() => setProfile("")}>
          {"Stop"}
        </Button>
      }
      sx={{
        position: "fixed",
        top: "0.375rem",
        right: "calc(50% - 9rem)",
        width: "18rem",
        padding: "0 0.625rem",
        zIndex: 999,
      }}
    >
      <b>{"Profiler active"}</b>
    </Alert>
  );
};

export default ProfilerBanner;
